import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import FocusLayout from 'layouts/FocusLayout';

import ErrorMessage from 'components/ErrorMessage';

import LoadingIndicator from 'primitives/LoadingIndicator';

const VERIFY_DEAL_INVITE_LINK_MUTATION = gql(`
  mutation VerifyDealInviteLink($id: ID!) {
    verifyDealInviteLink(id: $id) {
      id
    }
  }
`);

const DealInviteLinkPage: FC = () => {
  const navigate = useNavigate();
  const { dealInviteLinkId } = useParams<{ dealInviteLinkId: string }>() as {
    dealInviteLinkId: string;
  };

  const [verifyDealInviteLink, { loading, error, data }] = useMutation(
    VERIFY_DEAL_INVITE_LINK_MUTATION,
    {
      variables: {
        id: dealInviteLinkId,
      },
    }
  );

  useEffect(() => {
    verifyDealInviteLink().then(data => {
      if (!data.data?.verifyDealInviteLink?.id) return;
      navigate(`/invest/deal-invites/${data.data?.verifyDealInviteLink.id}`);
    });
  }, [navigate, verifyDealInviteLink]);

  const renderContent = () => {
    if (loading) return <LoadingIndicator />;

    if (error || !data) return <ErrorMessage error={error} />;

    return <div>{data && <p>Redirecting ...</p>}</div>;
  };

  return <FocusLayout>{renderContent()}</FocusLayout>;
};

export default DealInviteLinkPage;
